import React, {Component} from "react";
import ColorBasedValueProgressBar from "./ColorBasedValueProgressBar";

class PerformanceAndSkillsScoreBar extends Component {
    render = () => {
        const {title, value} = this.props;

        return (
            <div className="progress-bar-container">
                <div className="title-value-container">
                    <div className="title">{title} </div>
                    <span className="value"> {value} </span>
                </div>
                <div>
                    <ColorBasedValueProgressBar value={value}/>
                </div>
            </div>
        )
    };
}

export default PerformanceAndSkillsScoreBar;
